import TableComponent from '../../../Common/Charts/TableCharts';
import { number } from '../../../Common/Util/number';
import { usePoliceChartsDataContext } from './hooks/usePoliceChartsDataContext';

export const ByPoliceStationMonth = () => {
    const { chartData } = usePoliceChartsDataContext();

   const monthNames = [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Maio',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez'
    ];

    const tableColumns = [
            {
                key: 'ano_estatistica',
                header: 'Ano',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'mes_estatistica',
                header: 'Mês',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'delegacia',
                header: 'Delegacia',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'total',
                header: 'Total',
                headerStyle: { fontWeight: '500', textAlign: 'right' },
                cellStyle: { textAlign: 'right', fontWeight: '400' },
                formatter: (value) => number.formatToBRNumber(value)
            }
    ];

    const rawData = chartData?.byPoliceStationMonth || [];

    const flattenedData = rawData.flatMap((itemAno) => {
        return itemAno.delegacias.map((delegacia) => ({
            ...delegacia,
            ano_estatistica: itemAno.ano_estatistica,
            mes_estatistica: monthNames[itemAno.mes_estatistica - 1]
        }));
    });

    return (
        <div style={{ width: '100%' }}>
            <TableComponent
                data={flattenedData}
                columns={tableColumns}
                title="Por Delegacias (Mensal)"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="500px"
            />
        </div>
    );
};